"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _creatComment = _interopRequireDefault(require("./creatComment.vue"));
var _product = require("@/api/product");
var _index = require("@/utils/index");
var _permission = require("@/utils/permission");
var $constants = _interopRequireWildcard(require("@/utils/constants"));
var _public = require("@/libs/public");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  name: 'StoreComment',
  filters: {
    formatDate: function formatDate(time) {
      if (time !== 0) {
        var date = new Date(time * 1000);
        return (0, _index.formatDates)(date, 'yyyy-MM-dd hh:mm');
      }
    }
  },
  directives: {
    // 计算是否滚动到最下面
    selectLoadMore: {
      bind: function bind(el, binding) {
        // 获取element-ui定义好的scroll盒子
        var SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
        SELECTWRAP_DOM.addEventListener('scroll', function () {
          if (this.scrollHeight - this.scrollTop < this.clientHeight + 1) {
            binding.value();
          }
        });
      }
    }
  },
  components: {
    creatComment: _creatComment.default
  },
  data: function data() {
    return {
      fromList: this.$constants.fromList,
      tableData: {
        total: 0
      },
      listLoading: false,
      tableFrom: {
        page: 1,
        limit: $constants.page.limit[0],
        isReply: '',
        dateLimit: '',
        star: null,
        nickname: '',
        productSearch: '',
        searchType: 'all',
        content: ''
      },
      nickname: '',
      productSearch: '',
      timeVal: [],
      loading: false,
      dialogVisible: false,
      timer: ''
    };
  },
  watch: {
    $route: function $route(to, from) {
      this.getList();
    }
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['merchant:product:reply:page:list'])) this.getList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    handleSearchList: function handleSearchList() {
      this.dialogVisible = false;
      this.tableFrom.page = 1;
      this.getList();
    },
    //重置
    handleReset: function handleReset() {
      this.tableFrom.page = 1;
      this.tableFrom.isReply = '';
      this.tableFrom.dateLimit = '';
      this.tableFrom.star = null;
      this.tableFrom.nickname = '';
      this.tableFrom.productSearch = '';
      this.tableFrom.searchType = 'all';
      this.tableFrom.content = '';
      this.nickname = '';
      this.productSearch = '';
      this.selectChange();
    },
    // 回复
    reply: function reply(id) {
      var _this = this;
      this.$modalPrompt('textarea', '回复', null, '回复内容').then(function (V) {
        (0, _product.replyCommentApi)({
          id: id,
          merchantReplyContent: V
        }).then(function (res) {
          _this.$message({
            type: 'success',
            message: '回复成功'
          });
          _this.getList();
        });
      });
    },
    // 选择时间
    selectChange: function selectChange() {
      this.timeVal = [];
      this.tableFrom.page = 1;
      this.getList();
    },
    add: function add() {
      this.dialogVisible = true;
      this.timer = new Date().getTime();
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.$refs.formValidate.pics = [];
    },
    // 具体日期
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      this.tableFrom.dateLimit = e ? this.timeVal.join(',') : '';
      this.tableFrom.page = 1;
      this.getList();
    },
    // 删除
    handleDelete: function handleDelete(id, idx) {
      var _this2 = this;
      this.$modalSure().then(function () {
        (0, _product.replyDeleteApi)(id).then(function () {
          _this2.$message.success('删除成功');
          (0, _public.handleDeleteTable)(_this2.tableData.list.length, _this2.tableFrom);
          _this2.getList();
        });
      });
    },
    // 列表
    getList: function getList() {
      var _this3 = this;
      this.listLoading = true;
      this.tableFrom.nickname = encodeURIComponent(this.nickname);
      this.tableFrom.productSearch = encodeURIComponent(this.productSearch);
      if (this.tableFrom.star === 0) this.tableFrom.star = null;
      (0, _product.replyListApi)(this.tableFrom).then(function (res) {
        _this3.tableData = res;
        _this3.tableData.total = res.total;
        _this3.listLoading = false;
      }).catch(function () {
        _this3.listLoading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    }
  }
};